import { MemberCreatePage } from "@pages/memberCreate/MemberCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/gs-admin/members/enroll")({
  component: MemberCreatePage,
});
